if (!customElements.get("recipient-form")) {
  customElements.define(
    "recipient-form",
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this._onChange = this.onChange.bind(this);
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        if (this._isConnected) return;
        this._isConnected = true;

        this.cacheElements();
        if (!this.checkboxInput) return;

        this.checkboxInput.disabled = false;
        if (this.hiddenControlField) {
          this.hiddenControlField.disabled = true;
        }
        if (this.offsetProperty) {
          this.offsetProperty.value = new Date().getTimezoneOffset();
        }

        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener("change", this._onChange);
        this.onChange();

        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          (event) => {
            if (
              event.source === "product-form" &&
              event.productVariantId.toString() === this.currentProductVariantId
            ) {
              this.resetRecipientForm();
            }
          }
        );

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            if (event.data.sectionId === this.dataset.sectionId) {
              this.currentProductVariantId = event.data.variant.id.toString();
              this.dataset.productVariantId = this.currentProductVariantId;
            }
          }
        );

        this.cartErrorUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartError,
          (event) => {
            if (
              event.source === "product-form" &&
              event.productVariantId.toString() === this.currentProductVariantId
            ) {
              this.displayErrorMessage(event.message, event.errors);
            }
          }
        );
      }

      disconnectedCallback() {
        this._isConnected = false;
        this.removeEventListener("change", this._onChange);

        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
          this.cartUpdateUnsubscriber = undefined;
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
          this.variantChangeUnsubscriber = undefined;
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
          this.cartErrorUnsubscriber = undefined;
        }
      }

      cacheElements() {
        const sectionId = this.dataset.sectionId;
        this.checkboxInput = this.querySelector(
          `#Recipient-checkbox-${sectionId}`
        );
        this.hiddenControlField = this.querySelector(
          `#Recipient-control-${sectionId}`
        );
        this.emailInput = this.querySelector(`#Recipient-email-${sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${sectionId}`);
        this.messageInput = this.querySelector(
          `#Recipient-message-${sectionId}`
        );
        this.sendonInput = this.querySelector(
          `#Recipient-send-on-${sectionId}`
        );
        this.offsetProperty = this.querySelector(
          `#Recipient-timezone-offset-${sectionId}`
        );
      }

      onChange() {
        if (!this.checkboxInput) return;

        if (this.checkboxInput.checked) {
          this.enableInputFields();
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
        }
      }

      inputFields() {
        return [
          this.emailInput,
          this.nameInput,
          this.messageInput,
          this.sendonInput,
        ].filter(Boolean);
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty].filter(Boolean);
      }

      clearInputFields() {
        this.inputFields().forEach((field) => {
          field.value = "";
        });
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => {
          field.disabled = false;
        });
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => {
          field.disabled = true;
        });
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
        if (typeof body !== "object") return;

        Object.entries(body).forEach(([key, value]) => {
          const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
          const message = `${value.join(", ")}`;
          const errorMessageElement = this.querySelector(`#${errorMessageId}`);
          const errorTextElement =
            errorMessageElement?.querySelector(".error-message");
          if (!errorTextElement) return;

          errorTextElement.innerText = `${message}.`;
          errorMessageElement.classList.remove("hidden");

          const inputElement = this[`${key}Input`];
          if (!inputElement) return;

          inputElement.setAttribute("aria-invalid", true);
          inputElement.setAttribute("aria-describedby", errorMessageId);
        });
      }

      clearErrorMessage() {
        this.querySelectorAll(".recipient-fields .form__message").forEach(
          (field) => {
            field.classList.add("hidden");
            const textField = field.querySelector(".error-message");
            if (textField) textField.innerText = "";
          }
        );

        this.inputFields().forEach((inputElement) => {
          inputElement.setAttribute("aria-invalid", false);
          inputElement.removeAttribute("aria-describedby");
        });
      }

      resetRecipientForm() {
        if (!this.checkboxInput?.checked) return;

        this.checkboxInput.checked = false;
        this.clearInputFields();
        this.clearErrorMessage();
        this.disableInputFields();
        if (this.hiddenControlField) {
          this.hiddenControlField.disabled = true;
        }
      }
    }
  );
}
